import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  const version = localStorage.getItem("app_version");

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <div className="col-12">
              KDC © {new Date().getFullYear()} <span className="">| Version: {version}</span><br/>
              Developed By <a href="https://www.thebridgecode.com/">The Bridge Code</a>.
            </div>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
